// @flow
import React, { Component } from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import Button from "elevate-ui/Button";
import classNames from "classnames";
import BackgroundSlider from "react-background-slider";

import HeaderSearch from "../HeaderSearch";

type $Props = {
  classes: Object,
  backgroundImage: string,
  backgroundImages?: Array<string>,
  isCanadian: Function,
};

type $State = {
  isRental: boolean,
};

class CollapsedSearch extends Component<$Props, $State> {
  constructor(props) {
    super(props);

    this.state = {
      isRental: false,
    };
  }

  handleRentalState = (value: boolean) => this.setState({ isRental: value });

  render() {
    const {
      classes,
      backgroundImage,
      backgroundImages,
      isCanadian,
    } = this.props;
    const { isRental } = this.state;

    const innerPortion = (
      <div>
        <Typography type="heading2" className={classes.heading}>
          Search For Homes
        </Typography>
        <div className={classes.buttonGroup}>
          <Button
            className={classNames({
              [classes.button]: true,
              [classes.buttonActive]: !isRental,
            })}
            type="button"
            color={"rgba(0,0,0,.7)"}
            onClick={() => this.handleRentalState(false)}
          >
            Buy
          </Button>
          <Button
            className={classNames({
              [classes.button]: true,
              [classes.buttonActive]: isRental,
            })}
            type="button"
            color={"rgba(0,0,0,.7)"}
            onClick={() => this.handleRentalState(true)}
          >
            Rent
          </Button>
          <Button
            className={classes.button}
            element="a"
            href="/sell"
            type="button"
            color="rgba(0,0,0,.7)"
          >
            Sell
          </Button>
        </div>
        <div className={classes.searchContainer}>
          <HeaderSearch
            showColorButtons={false}
            isRental={isRental}
            isCanadian={isCanadian()}
          />
        </div>
      </div>
    );

    if (backgroundImages && backgroundImages.length > 1) {
      return (
        <div className={classes.root}>
          <BackgroundSlider
            images={backgroundImages}
            duration={5}
            transition={2}
          />
          <div className={classes.backgroundImagesOverlay}>{innerPortion}</div>
        </div>
      );
    }

    return (
      <div
        className={classes.root}
        style={{
          background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}) center/cover no-repeat`,
        }}
      >
        {innerPortion}
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "70vh",
    width: "100%",
  },
  backgroundImagesOverlay: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#00000050",
    width: "100%",
    height: "70vh",
  },
  heading: {
    textTransform: "uppercase",
    textAlign: "center",
    color: theme.colors.white,
  },
  buttonGroup: {
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    alignItems: "center",
    width: "92%",
  },
  button: {
    width: "33.3333%",
    height: "52px",
    border: `1px solid ${theme.colors.gray["100"]}`,
    borderRadius: "0",
    "&:nth-child(2)": {
      borderLeft: "none",
      borderRight: "none",
    },
    [theme.breakpoints(678)]: {
      width: "204px",
    },

    "&:hover": {
      backgroundColor: "rgba(0,0,0,0)",
    },
  },
  buttonActive: {
    backgroundColor: theme.colors.primary["500"],
    "&:hover": {
      backgroundColor: theme.colors.primary["500"],
    },
  },
  searchContainer: {
    position: "relative",
    width: "100%",
    maxWidth: "612px",
    margin: "24px auto",
    padding: "0 24px",
    [theme.breakpoints(678)]: {
      padding: "0",
    },
  },
});

export default withGlobalContext(withStyles(styles)(CollapsedSearch));
